import { render, staticRenderFns } from "./BtnetNavbar.vue?vue&type=template&id=56d1c73c&"
import script from "./BtnetNavbar.vue?vue&type=script&lang=js&"
export * from "./BtnetNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports